module.exports = __webpack_public_path__ + "static/media/email.192d54c8.svg";